<pf-listview [items]="categories" [title]="'category.title' | translate" [addRouterLink]="'/addcategory'"
    [hasSearchSection]="true" [searchPlaceholder]="'category.searchPlaceholder' | translate">
    <ng-template #itemTemplate let-category let-i="index">
        <div class="banner-row-layout">
            <div class="name-link" [routerLink]="[category.id]">
                {{ category.name }}
            </div>

            <div class="status-block">
                <div class="delete">
                    <mat-icon (click)="openDeleteCategoryDialog(category); $event.stopPropagation()">
                        delete_forever
                    </mat-icon>
                </div>
            </div>
        </div>
    </ng-template>
</pf-listview>